// SPDX-License-Identifier: AGPL-3.0-or-later

import {MessageFlags} from '@fluxer/constants/src/ChannelConstants';

/** True when the message is a server-authored self-delete tombstone. */
export function isDeleteTombstone(message: {hasFlag: (flag: number) => boolean}): boolean {
	return message.hasFlag(MessageFlags.DELETE_TOMBSTONE);
}

/** True when edit should be a no-op because the stored message is a tombstone. */
export function shouldRefuseMessageEdit(message: {hasFlag: (flag: number) => boolean} | null | undefined): boolean {
	return message != null && isDeleteTombstone(message);
}
